angular.module('bbl.directives')
.directive('dialBtn', [ '$parse', DialBtn ]);

function DialBtn($parse) {
  return {
    restrict: 'E',
    template: '<ng-transclude></ng-transclude>',
    transclude: true,
    link: function($scope, $el, atts) {

      var keyCode = {
        '*': 'star',
        '#': 'pound',
      }[atts.code] || atts.code;

      var audio = angular.element('<audio src="https://s3.amazonaws.com/plivosdk/audio/dtmf-'+keyCode+'.mp3"></audio>');
      $el.append(audio);

      $el.on('click', audio[0].play.bind(audio[0]));

      $scope.tone = audio[0].play.bind(audio[0]);
      var refFn = $parse(atts.ref)($scope);
    }
  };
}



/*****************
 ** WEBPACK FOOTER
 ** ./app/common/directives/dialpad-widget/dial-btn.directive.js
 ** module id = 179
 ** module chunks = 0
 **/